<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="myExtraLargeModalLabel">
      <ng-container *ngIf="isEditing">
        Edit Sink Node Mapping
      </ng-container>
      <ng-container *ngIf="!mappedField?.id">
        Add Sink Node Mapping
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" [formGroup]="mappedFieldForm" role="form" autocomplete="off">
      <div class="form-group row">
        <label class="col-3 col-form-label">Participant Id</label>
        <label class="col-9 col-form-label">{{mappedField.participantId}}</label>
      </div>

      <div class="form-group row">
        <label class="col-3 col-form-label">Map description</label>
        <div class="col-9">
          <ng-select2 [data]="filteredMappedDescriptions" formControlName="mapDescription" [options]="select2options" placeholder="Map description"></ng-select2>
          <ul *ngIf="submitted || mappedFieldForm.controls.mapDescription.touched" class="parsley-errors-list filled">
            <li *ngIf="mappedFieldForm.controls.mapDescription.hasError('required')" class="parsley-required">Map Description is required</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-3 col-form-label">Sink Node</label>
        <div class="col-9">
          <ng-select2 [data]="filteredSinkNodes" [options]="select2options"
                      formControlName="sinkNode" placeholder="Sink Node" width="100px"></ng-select2>
          <ul *ngIf="submitted || mappedFieldForm.controls.sinkNode.touched" class="parsley-errors-list filled">
            <li *ngIf="mappedFieldForm.controls.sinkNode.hasError('required')" class="parsley-required">Sink Node is required</li>
          </ul>
        </div>
      </div>

      <div class="form-group row float-right">
        <div class="col-12">
          <button *ngIf="isEditing" type="submit" class="btn waves-effect waves-light" [ngClass]="{ 'btn-danger': true }" (click)="triggerOption('delete')"><i class="mdi mdi-delete-outline mr-1"></i>Delete</button>
          <button *ngIf="isEditing" type="submit" class="btn btn-info waves-effect waves-light" (click)="triggerOption('update')"><i class="mdi mdi-content-save mr-1"></i>Save</button>
          <button *ngIf="!isEditing" type="submit" class="btn btn-info waves-effect waves-light" (click)="triggerOption('create')"><i class="mdi mdi-content-save mr-1"></i>Create</button>
        </div>
      </div>
    </form>
  </div>
</div>
